import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface PaymentExecutionActionsProps {
  revocable: boolean
  expensableId?: number
  financialDocumentId?: number
  onRevoke?: () => void
}

export const Actions = ({
  revocable,
  onRevoke,
  expensableId,
  financialDocumentId,
}: PaymentExecutionActionsProps) => {
  const { navigation } = useNavigation()

  if (!revocable && !expensableId && !financialDocumentId) {
    return null
  }

  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      <PopoverMenu type="list">
        {!!revocable && (
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </PopoverMenu.Trigger>
        )}
        {!!expensableId && (
          <PopoverMenu.Trigger>
            <Button.Router
              type="secondary"
              iconName="arrow-right"
              to={navigation.expenses.list.expenses.expenseId.fullPath({
                expense_id: expensableId,
              })}
            />
          </PopoverMenu.Trigger>
        )}
        {!!financialDocumentId && (
          <PopoverMenu.Trigger>
            <Button.Router
              type="secondary"
              iconName="arrow-right"
              to={navigation.finance.invoices.list.invoiceId.fullPath({
                invoiceId: financialDocumentId,
              })}
            />
          </PopoverMenu.Trigger>
        )}
        {revocable && (
          <PopoverMenu.Content side="bottom" align="start">
            <PopoverMenu.TouchableOption
              title={i18n.t('banking.transfers.actions.remove_transfer')}
              onClick={onRevoke}
            />
          </PopoverMenu.Content>
        )}
      </PopoverMenu>
    </Box>
  )
}
